import { useQuery } from '@tanstack/react-query';
import { fetchCarePlanCurrentScores } from '../services/care_plan';

const useCarePlanCurrentScore = (patientId, carePlanType, fromDate, toDate) => {
    return useQuery({
        queryKey: ['carePlanCurrentScores', patientId, carePlanType, fromDate, toDate],
        queryFn: () => fetchCarePlanCurrentScores(patientId, carePlanType, fromDate, toDate),
        enabled: !!patientId && !!carePlanType,
        staleTime: 0, // always refetch so newly signed careplans update the current score
    });
};

export default useCarePlanCurrentScore;
